/* eslint-disable no-console */

import { register } from 'register-service-worker';

if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            // Service worker is ready
        },
        registered() {
            // Service worker registered
        },
        cached() {
            // Service worker cached
        },
        updatefound() {
            // Service worker update found
        },
        updated() {
            // Service worker updated
        },
        offline() {
            // App offline
        },
        error(error) {
            console.error('Error during service worker registration:', error);
        },
    });
}
